export const COMPANION_APP_URL =
	process.env.REACT_APP_COMPANION_APP_URL || 'https://spa.doorjames.app';
